import getters from './getters';
import mutations from './mutations';
function initState() {
    return {
        listData: [],
        countMap: {}
    };
}

export default {
    namespaced: true,
    state: initState,
    getters,
    mutations,
    actions: {}
};
